// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"70b1fab8","261":"dccc50e3","387":"02b19ca7","625":"d159e5a5","629":"21ef931d","785":"f1fa41a4","790":"c4fc5a64","883":"7c264e3c","928":"7c264e3c","951":"61234b4f"}[chunkId] + ".chunk.css";
};